module.exports = __webpack_public_path__ + "img/hospitium-11.b91e33c4.jpg";